import { render } from "./mispadres2.vue?vue&type=template&id=45621bab&scoped=true"
import script from "./mispadres2.vue?vue&type=script&lang=js"
export * from "./mispadres2.vue?vue&type=script&lang=js"

import "./mispadres2.vue?vue&type=style&index=0&id=45621bab&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45621bab"]])

export default __exports__